import { render, staticRenderFns } from "./user-form.vue?vue&type=template&id=07b9aabb"
import script from "./user-form.vue?vue&type=script&lang=ts"
export * from "./user-form.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports